import {
  ProductsImportConfigComponent
} from "@features/accounts/run-products/products-import-config/products-import-config.component";
import {
  PayoutImportConfigComponent
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/payout-import-config/payout-import-config.component";
import {MaterialModule} from "@modules/material.module";
import {AppCoreModule} from "@modules/app.core.module";
import {AppSharedModule} from "@modules/app-shared.module";
import {NgModule} from "@angular/core";

import {
  PayoutHistoryListComponent
} from "@features/accounts/payout-history/payout-history-list/payout-history-list.component";
import {
  RunClientPayoutsViewComponent
} from "@features/accounts/run-client-payouts/run-client-payouts-view/run-client-payouts-view.component";
import {
  PaymentBatchTransactionsComponent
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/payment-batches-list/payment-batch-dialog/payment-batch-transactions.component";
import {
  PaymentBatchesListComponent
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/payment-batches-list/payment-batches-list.component";
import {
  PaymentGroupsComponent
} from '@features/accounts/run-tenant-payouts/run-tenant-payouts-view/payment-groups/payment-groups.component';
import {
  PayoutJobcardComponent
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/payout-jobcard/payout-jobcard.component";
import {
  PayoutMinimumAmountComponent
} from '@features/accounts/run-tenant-payouts/run-tenant-payouts-view/payout-minimum-amount/payout-minimum-amount.component';
import {
  RunTenantPayoutsViewComponent
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/run-tenant-payouts-view.component";
import {
  DailyTransactionSummaryComponent
} from "@features/accounts/transactions/transactions-list-view/daily-transaction-summary/daily-transaction-summary.component";
import {
  TransactionsListViewComponent
} from "@features/accounts/transactions/transactions-list-view/transactions-list-view.component";
import {
  TransactionsScheduleComponent
} from "@features/accounts/transactions/transactions-list-view/transactions-schedule/transactions-schedule.component";
import {TradingReportComponent} from "@features/accounts/trading-report/trading-report.component";
import {
  ErrorTradingReportComponent
} from "@features/accounts/trading-report/error-trading-report/error-trading-report.component";
import {ProductsJobcardComponent} from "@features/accounts/run-products/products-jobcard/products-jobcard.component";
import {
  RetailerTradingReportComponent
} from "@features/accounts/trading-report/retailer-trading-report/retailer-trading-report.component";
import {RunProductsComponent} from "@features/accounts/run-products/run-products.component";
import {
  TotalTradingReportComponent
} from "@features/accounts/trading-report/total-trading-report/total-trading-report.component";
import {
  ActivePayoutGroups
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/active-payout-groups/active-payout-groups.component";
import {CrudTableComponent} from '@ui-kit/webkit/components/crud-table/crud-table.component';
import {CustomDateFilterComponent} from '@ui-kit/webkit/components/custom-date-filter/custom-date-filter.component';


const components = [
  DailyTransactionSummaryComponent,
  PaymentBatchTransactionsComponent,
  PaymentBatchesListComponent,
  PaymentGroupsComponent,
  PayoutHistoryListComponent,
  PayoutJobcardComponent,
  PayoutMinimumAmountComponent,
  RunClientPayoutsViewComponent,
  RunTenantPayoutsViewComponent,
  TransactionsListViewComponent,
  TransactionsScheduleComponent,
  TradingReportComponent,
  ErrorTradingReportComponent,
  ProductsJobcardComponent,
  RetailerTradingReportComponent,
  RunProductsComponent,
  TotalTradingReportComponent,
  ActivePayoutGroups
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule,
    CrudTableComponent,
    CustomDateFilterComponent,
    PayoutImportConfigComponent,
    ProductsImportConfigComponent
  ],
  declarations: [...components],
  exports: [...components],
  providers: []
})
export class FeatureAccountsModule {
}
